import Action from './Action'
// import './styles/ModalCreateException.css'
import { useState, useEffect } from 'react';
import LoadSimple from './LoadSimple';
import InputAdmin from './InputAdmin';
import { useFetch } from '../hooks/useFetch';
import SelectorAdmin from './SelectorAdmin';
import { capitalizeFirstLetter } from '../utils/utils';
import { lang } from './generales/traduction';
import { el } from 'date-fns/locale';

const ModalCreateAck = ({ props, closeAck }) => {
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');

        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
    };
    //   const dataAgencies=useFetch('cassia/exception_agencies','','','GET',server)

    const [loadingM, setLoadingM] = useState(false);
    const [IpValid, setIpValid] = useState(true)
    const [matchPassword, setMatchPassword] = useState(false)
    const [disabled, setDisabled] = useState(true)
    const [host, sethost] = useState([])
    const [closeEvent, setCloseEvent] = useState(false);
    const [falsePosiive, setFalsePosiive] = useState(false);
    const [agenciaId, setAgenciaId] = useState(props.dataAgencies.data.length != 0 ? props.dataAgencies.data.data[0].exception_agency_id : 1);
    const [ManttoData, setManttoData] = useState({
        description: "",
        closeEvent: closeEvent,

    })
    const [excepcion, setExcepcion] = useState('');
    const [addingException, setAddingException] = useState(false);

    // *** NUEVO: ESTO SOLUCIONA TU CASO ***
    // Si desmarcas "Falso Positivo", desmarca automáticamente "Cerrar Evento"
    useEffect(() => {
        if (!falsePosiive) {
            setCloseEvent(false);
        }
    }, [falsePosiive]);
    // *************************************


    //   useEffect(()=>{

    //         if( (ManttoData.agency_id===0 || ManttoData.agency_id==="") || IpValid===false   ){
    //             console.log('disabled')
    //             setDisabled(true)
    //         }else{
    //             console.log('no disabled')
    //             setDisabled(false)
    //         }
    //   },[ManttoData])


    const addAck = async (e) => {
        setAddingException(true)
        //console.log(props.data)
        // ////console.log("element_id:"+cisSelected.element_id+" | ci-relation:"+cisRelation)

        const formData = new URLSearchParams();
        formData.append("message", ManttoData.description);
        formData.append("close", closeEvent);
        formData.append("is_zabbix_event", ((props.data.alert_type == "") ? true : false));
        formData.append("is_valid", ((falsePosiive) ? 0 : 1));
        //console.log(props.server.url+'/api/v1/zabbix/problems/acknowledge/'+props.data.eventid)
        let url = (props.data.alert_type === 'correlation') ? props.server.url + '/api/v1/cassia/events_correlations/acknowledge/' + props.data.eventid : props.server.url + '/api/v1/zabbix/problems/acknowledge/' + props.data.eventid
        try {
            // const response = await fetch(props.server.url+'/api/v1/zabbix/problems/acknowledge/'+props.data.eventid, {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/x-www-form-urlencoded",
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                },
                body: formData
            });
            if (response.ok) {
                const data = await response.json();
                if (!closeEvent) {
                    trigger_ack()
                } else {
                    trigger_close_ack()
                }
                // props.search_problems()
                closeAck()
                props.handleShowPopup(capitalizeFirstLetter(lang[props.languaje]['completado']), capitalizeFirstLetter((lang[props.languaje]['regGenCorr'])), '', true)


                //   setCloseEvent(false)
                //   setAckOpen(false);
                props.setSearchTerm("")
                setAddingException(false)
                props.search_problems()
            } else {
                const data = await response.json();
                //console.log(data.detail)
                //   setCloseEvent(false)
                //   setResponseDetail(data.detail)
                throw new Error('Error en la solicitud');
            }
        } catch (error) {
            setAddingException(false)
            //console.log(error)

        }
    }
    const trigger_ack = async (e) => {


        //console.log(props.server.url+'/api/v1/zabbix/problems/acknowledge/'+props.data.eventid)

        try {
            const response = await fetch(props.server.url + '/api/v1/cassia/surveys/trigger_ack_creation', {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                },
            });
            //console.log(response)
            if (response.ok) {
                const data = await response.json();
                if (data.data.survey_id != null) {
                    props.setImportModalOpen(true);
                    props.setSuveryId(data.data.survey_id)
                }
            } else {
                const data = await response.json();
                //console.log(data.detail)
                //   setCloseEvent(false)
                //   setResponseDetail(data.detail)
                throw new Error('Error en la solicitud');
            }

        } catch (error) {
            setAddingException(false)
            //console.log(error)

        }
    }
    const trigger_close_ack = async (e) => {


        //console.log(props.server.url+'/api/v1/zabbix/problems/acknowledge/'+props.data.eventid)

        try {
            const response = await fetch(props.server.url + '/api/v1/cassia/surveys/trigger_event_closing', {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                },
            });
            //console.log(response)
            if (response.ok) {
                const data = await response.json();
                if (data.data.survey_id != null) {
                    props.setImportModalOpen(true);
                    props.setSuveryId(data.data.survey_id)
                }
            } else {
                const data = await response.json();
                //console.log(data.detail)
                //   setCloseEvent(false)
                //   setResponseDetail(data.detail)
                throw new Error('Error en la solicitud');
            }

        } catch (error) {
            setAddingException(false)
            //console.log(error)

        }
    }

    const changeOption = (option, index) => {
        setManttoData((prevState) => {
            return {
                ...prevState,
                ['exception_agency_id']: option.value === "" ? 0 : (parseInt(option.value))
            }

        })
        // setManttoRelation(option.value)
    }


    const handleChange = (e) => {
        const { name, value } = e.target
        setManttoData((prevState) => {
            return {
                ...prevState,
                [name]: value
            }

        })
    }
    const handleTextAreaChange = (event) => {
        setManttoData((prevState) => {
            return {
                ...prevState,
                ['description']: event.target.value
            }

        })
    };
    const { description,

        hostid,
        created_at } = ManttoData;
    return (
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                       { capitalizeFirstLetter(lang[props.languaje]['cearAcknownledge']) }
                    </div>
                </div>
                <div className='content-card-modal-gs'>
                    {1 == 1 ?
                        // nivelForm===1?
                        <>
                            <div className="form-GS-box">

                                <div className="user-box-GS" style={{ height: '25%' }}>
                                    <input required name="name" type="text" value={props.data.eventid} disabled
                                    />
                                    <label className='label-GS'> {'Event ID'}</label>


                                </div>

                                <div className="user-box-GS" style={{ height: '25%' }}>
                                    {/* <div className='contListIconsAgencys' style={{border:'unset'}}> */}

                                    <input required name="description" type="text" value={description} onChange={handleTextAreaChange} />
                                    <label className='label-GS'>{capitalizeFirstLetter(lang[props.languaje]['notas'])}</label>

                                </div>
                                <div className="user-box-GS" style={{ height: '15%' }}>
                                    {((props.data.r_eventid == "" || props.data.r_eventid == null) && props.data.manual_close == 1) ?
                                        <>
                                            <input
                                                value={1}
                                                name="ce"
                                                type="checkbox"
                                                id={`close-event`}
                                                // AJUSTE MÍNIMO: Usamos checked y onChange referenciando a su propia variable
                                                // para que el estado se actualice real y desbloquee el otro botón.
                                                checked={falsePosiive}
                                                onChange={() => setFalsePosiive(!falsePosiive)}
                                            />
                                            <label htmlFor={`close-event`} style={{
                                                color: 'var(--txt-color)', fontSize: 'var(--font-size-small)', position: 'relative',
                                                left: '-30%',
                                                width: '30%'
                                            }}>{capitalizeFirstLetter(lang[props.languaje]['falsoPositivo'])}</label>
                                        </> : ''
                                    }
                                </div>
                                {/* 2. CHECKBOX CERRAR EVENTO */}
                                <div className="user-box-GS" style={{ height: '15%' }}>
                                    {
                                        ((props.data.r_eventid == "" || props.data.r_eventid == null) && props.data.manual_close == 1) ?
                                            <>
                                                <input
                                                    value={1}
                                                    name="ce"
                                                    type="checkbox"
                                                    id={`close-event`}
                                                    // Se deshabilita si: 
                                                    // 1. NO es falso positivo (!falsePosiive)
                                                    // 2. O SI el evento ya está resuelto (props.data.value == 0)
                                                    disabled={!falsePosiive && props.data.Estatus != "RESOLVED"}
                                                    checked={closeEvent}
                                                    onChange={() => setCloseEvent(!closeEvent)}
                                                />
                                                <label
                                                    htmlFor={`close-event`}
                                                    style={{
                                                        // Feedback visual: Gris si está bloqueado por cualquiera de las dos razones
                                                        color: (!falsePosiive && props.data.Estatus != "RESOLVED") ? 'gray' : 'var(--txt-color)',
                                                        fontSize: 'var(--font-size-small)',
                                                        position: 'relative',
                                                        left: '-30%',
                                                        width: '30%',
                                                        // Cursor de prohibido si está bloqueado
                                                        cursor: (!falsePosiive && props.data.Estatus != "RESOLVED") ? 'not-allowed' : 'pointer'
                                                    }}>
                                                    {capitalizeFirstLetter(lang[props.languaje]['cerrarEvento'])}
                                                </label>
                                            </> : ''
                                    }
                                </div>

                                <div className="user-box-admin" style={{ height: '25%' }}>
                                    {
                                        (addingException) ? <LoadSimple></LoadSimple>
                                            :
                                            <>
                                                <Action origen='Azul' titulo={capitalizeFirstLetter(lang[props.languaje]['crear'])} action={addAck} disabled={false} />
                                                <Action origen='Cancelar' titulo={capitalizeFirstLetter(lang[props.languaje]['cancelar'])} action={closeAck} disabled={false} /></>
                                        // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                    }

                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>{'Usuario '+(editActive? 'editado':'registrado' )+' correctamente'}</span>:''
                                    }

                                </div>
                            </div>
                        </>
                        : ''

                    }
                </div>
            </div>
        </div>
    )
}

export default ModalCreateAck